export function navigateTo(path: string): void {
  const next = toInternalUrl(path);
  if (!next) {
    window.location.assign(path);
    return;
  }
  if (next === `${window.location.pathname}${window.location.search}${window.location.hash}`) {
    return;
  }
  window.history.pushState(null, "", next);
  window.dispatchEvent(new PopStateEvent("popstate"));
  window.scrollTo({ top: 0, left: 0 });
}

export function replaceWith(path: string): void {
  const next = toInternalUrl(path);
  if (!next) {
    window.location.replace(path);
    return;
  }
  window.history.replaceState(null, "", next);
  window.dispatchEvent(new PopStateEvent("popstate"));
  window.scrollTo({ top: 0, left: 0 });
}

function toInternalUrl(path: string): string | null {
  const url = new URL(path, window.location.href);
  if (url.origin !== window.location.origin) return null;
  return `${url.pathname}${url.search}${url.hash}`;
}

export function handleLinkClick(event: MouseEvent, path: string): void {
  if (
    event.defaultPrevented ||
    event.metaKey ||
    event.ctrlKey ||
    event.shiftKey ||
    event.altKey ||
    event.button !== 0
  ) {
    return;
  }

  event.preventDefault();
  navigateTo(path);
}

export function handleInternalAnchorClick(event: MouseEvent): void {
  const target = event.target;
  if (!(target instanceof Element)) return;

  const anchor = target.closest("a[href]");
  if (!(anchor instanceof HTMLAnchorElement)) return;
  if (anchor.target && anchor.target !== "_self") return;

  const url = new URL(anchor.href, window.location.href);
  if (url.origin !== window.location.origin) return;

  handleLinkClick(event, `${url.pathname}${url.search}${url.hash}`);
}

export function safeInternalPath(value: string | null | undefined): string {
  if (!value) return "/";
  return value.startsWith("/") && !value.startsWith("//") ? value : "/";
}

/**
 * For sidebar active-state: `/app/dashboard` is treated like `/dashboard`.
 * Paths under `/app/admin` are unchanged (those routes live under `/app/admin`).
 */
export function canonicalPathForNav(pathname: string): string {
  if (/^\/app\/(dashboard|alerts|work|integrations|registry)(\/|$)/.test(pathname)) {
    return pathname.slice(4);
  }
  return pathname;
}

export function pathParam(regex: RegExp, index: number): string {
  const pathname = window.location.pathname;
  const match = pathname.match(regex) ?? canonicalPathForNav(pathname).match(regex);
  const value = match?.[index];
  return value ? decodeURIComponent(value) : "";
}
